import {
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren
} from "@angular/core";
import {ModalDirective} from "ngx-bootstrap";
import {WithdrawalDataFormComponent} from "../../../../../store-management/withdrawal/withdrawal-data-form/withdrawal-data-form.component";

@Component({
  selector: 'vb-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.css']
})
export class GenericModalComponent implements OnInit {

  @Input()
  modalSize: 'sm' | 'lg' | null = null;

  @Input()
  mainContentTmpl: TemplateRef<any>;

  @Input()
  modalTitle: string = "";

  @Output()
  closed: EventEmitter<ModalCloseActions> = new EventEmitter<ModalCloseActions>();

  @Output()
  okClicked: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  cancelClicked: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  isStatic: boolean = false;

  @Input()
  showFooter: boolean = true;

  @Input()
  successLabel: string = "Ok";

  @Input()
  cancelLabel: string = "Abbrechen";

  @Input()
  okEnabled: boolean = true;

  @Input()
  cancelEnabled: boolean = true;

  @Input()
  showCancel: boolean = true;

  @Input()
  showSuccess: boolean = true;

  @Input()
  enableEnterKeyPress: boolean = false;

  @Input()
  enableEscKeyPress: boolean = true;

  @Input()
  state: any = {};

  @ViewChild('modal')
  modal: ModalDirective;

  @ContentChildren(WithdrawalDataFormComponent)
  childComponents: QueryList<Component>;

  @ViewChildren(Component)
  components: QueryList<Component>;

  ModalCloseActions;

  constructor(private cd: ChangeDetectorRef) {
    this.ModalCloseActions = ModalCloseActions;
  }

  ngOnInit(): void {

  }

  /* ngAfterViewInit() {
   this.modal.show();
   this.modal.onHide.subscribe((hide: any) =>{
   this.closed.emit(ModalCloseActions.CANCEL);
   });
   }*/

  show() {
    this.cd.detectChanges();
    this.modal.show();
  }

  onEnterKeyPress() {
    if (this.enableEnterKeyPress) {
      this.ok();
    }
  }

  onEscKeyPress() {
    if (this.enableEscKeyPress) {
      this.cancel();
    }
  }

  ok() {

    if (!this.okEnabled) {
      return;
    }

    this.okClicked.emit();
    setTimeout(() => {
      this.hide(ModalCloseActions.SUCCESS);
    });

  }

  cancel() {
    if (!this.cancelEnabled) {
      return;
    }

    this.cancelClicked.emit();
    setTimeout(() => {
      this.hide(ModalCloseActions.SUCCESS);
    });
  }

  hide(closeAction?: ModalCloseActions) {
    this.modal.hide();
    this.closed.emit(closeAction);
  }

  public isVisible(): boolean {
    return this.modal ? this.modal.isShown : false;
  }

}

export enum ModalCloseActions {
  CANCEL, SUCCESS
}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/forms/generic-modal/generic-modal.component.ts